import { render, staticRenderFns } from "./FaqCreateEdit.vue?vue&type=template&id=295dc31d&scoped=true&"
import script from "./FaqCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FaqCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295dc31d",
  null
  
)

export default component.exports